import {
  FaGlobeAmericas,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaGithub,
  FaDribbble,
  FaInstagram,
} from 'react-icons/fa';
import { MdPhone, MdEmail } from 'react-icons/md';

const Icons = {
  phone: MdPhone,
  website: FaGlobeAmericas,
  email: MdEmail,
  facebook: FaFacebookF,
  twitter: FaTwitter,
  linkedin: FaLinkedinIn,
  github: FaGithub,
  dribbble: FaDribbble,
  instagram: FaInstagram,
};

export default Icons;
